import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const SpecialOffer = () => {
  const [copiesLeft, setCopiesLeft] = useState(374);
  useEffect(() => {
    // Get stored value from localStorage or use default
    const storedCopies = localStorage.getItem('copiesLeft');
    const initialCopies = storedCopies ? parseInt(storedCopies) : 374;
    setCopiesLeft(initialCopies);
    // Decrease count randomly every 3 seconds
    const interval = setInterval(() => {
      setCopiesLeft(prevCount => {
        // Random decrease between 1-3
        const decrease = Math.floor(Math.random() * 3) + 1;
        const newCount = Math.max(prevCount - decrease, 5); // Don't go below 5
        // Store in localStorage
        localStorage.setItem('copiesLeft', newCount.toString());
        return newCount;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div id="offer" className="py-16 bg-gradient-to-br from-gray-100 via-white to-red-50 relative" data-id="element-155">
      {/* Subtle background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-156">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/subtle-dots.png')"
      }} data-id="element-157"></div>
      </div>
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-158">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center" data-id="element-159">
          <span className="text-red-700 mr-2" data-id="element-160">★</span>
          Special Release Offer
        </h2>
        <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-12 relative overflow-hidden" data-id="element-161">
          {/* Limited edition corner ribbon */}
          <div className="absolute top-0 right-0 w-32 h-32 overflow-hidden" data-id="element-162">
            <div className="absolute top-0 right-0 transform translate-x-12 -translate-y-2 rotate-45 w-40 h-10 bg-red-700 text-white text-sm font-bold flex items-center justify-center shadow-lg border border-white z-20" data-id="element-163">
              LIMITED EDITION
            </div>
          </div>
          {/* Countdown banner */}
          <div className="bg-red-600 text-white text-center py-2 px-4 rounded-md mb-6 shadow-md" data-id="element-164">
            <p className="font-bold" data-id="element-165">
              URGENT: Only{' '}
              <span className="text-yellow-300 text-xl" data-id="element-166">{copiesLeft}</span>{' '}
              copies left at this price!
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center gap-8 mb-8" data-id="element-167">
            <div className="md:w-1/3 relative" data-id="element-168">
              <div className="absolute inset-0 rounded-md bg-gradient-to-tr from-red-700/20 via-white/20 to-gray-700/20" data-id="element-169"></div>
              {/* Book Cover */}
              <div className="relative" data-id="element-170">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/p5mRdC7C2nJqDGZ5kmDcdj/Generated_Image_September_21%2C_2025_-_2_09PM.png" alt="When Schools Become Targets Book Cover" className="w-full max-w-xs mx-auto shadow-xl rounded-md relative z-10" data-id="element-171" />
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-172">
              <div className="flex flex-col md:flex-row gap-6 mb-6" data-id="element-173">
                {/* Digital Option */}
                <div className="flex-1 border-2 border-gray-700 rounded-lg p-4 bg-gray-50 shadow-md" data-id="element-174">
                  <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-175">
                    Digital Copy
                  </h3>
                  <p className="text-xl line-through text-gray-500" data-id="element-176">$47.97</p>
                  <p className="text-3xl font-bold text-red-700" data-id="element-177">$19.97</p>
                  <p className="text-green-700 font-medium mt-2" data-id="element-178">
                    Instant Download
                  </p>
                  <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-179">
                    <p className="font-medium text-gray-800" data-id="element-180">
                      Includes 3 FREE Bonus Resources!
                    </p>
                  </div>
                  <a href="https://www.voicesoffreedomus.com/cart/45169026990266:1" className="mt-4 inline-block w-full bg-gray-700 hover:bg-gray-800 text-white font-bold py-3 px-4 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-181">
                    Get Digital Copy Now
                  </a>
                </div>
                {/* Physical Option */}
                <div className="flex-1 border-2 border-red-700 rounded-lg p-4 bg-red-50 shadow-md relative" data-id="element-182">
                  <h3 className="text-xl font-bold text-red-800 mb-2" data-id="element-183">
                    Physical Copy
                  </h3>
                  <p className="text-xl line-through text-gray-500" data-id="element-184">$67.97</p>
                  <p className="text-3xl font-bold text-red-700" data-id="element-185">$34.97</p>
                  <p className="text-amber-700 font-medium mt-2" data-id="element-186">
                    Shipping: 14 days (high demand)
                  </p>
                  <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-187">
                    <p className="font-medium text-gray-800" data-id="element-188">
                      Includes 3 FREE Bonus Resources!
                    </p>
                  </div>
                  <a href="https://www.voicesoffreedomus.com/cart/45168987603130:1" className="mt-4 inline-block w-full bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-4 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-189">
                    Order Physical Copy
                  </a>
                </div>
                {/* Premium Hardcover Option */}
                <div className="flex-1 border-2 border-gray-800 rounded-lg p-4 bg-gray-50 shadow-md relative" data-id="element-190">
                  {/* PREMIUM Badge */}
                  <div className="absolute -top-3 -right-3 z-20" data-id="element-191">
                    <div className="bg-red-700 text-white text-xs font-bold px-3 py-1 rounded-full transform shadow-lg border border-white" data-id="element-192">
                      PREMIUM
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-193">
                    Premium Hardcover
                  </h3>
                  <p className="text-xl line-through text-gray-500" data-id="element-194">$127.97</p>
                  <p className="text-3xl font-bold text-red-700" data-id="element-195">$74.97</p>
                  <p className="text-amber-700 font-medium mt-2" data-id="element-196">
                    Shipping: 14 days (high demand)
                  </p>
                  <div className="mt-2 mb-3" data-id="element-197">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sBZsYSpsNLUxPwuCNDvLWf/book-on_table.png" alt="Premium Hardcover Edition" className="w-full rounded-md shadow-md" data-id="element-198" />
                  </div>
                  <div className="mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-3" data-id="element-199">
                    <p className="font-medium text-gray-800" data-id="element-200">
                      Includes 3 FREE Bonus Resources!
                    </p>
                  </div>
                  <a href="https://www.voicesoffreedomus.com/cart/45169046782138:1" className="mt-4 inline-block w-full bg-gray-800 hover:bg-gray-900 text-white font-bold py-3 px-4 rounded-lg text-center transition-colors duration-300 shadow-md" data-id="element-201">
                    Order Premium Edition
                  </a>
                </div>
              </div>
              <div className="bg-gray-100 border-l-4 border-red-700 p-4 mb-6" data-id="element-202">
                <p className="text-lg font-medium" data-id="element-203">
                  Each edition includes FREE bonus resources on prevention
                  strategies and survivor testimonies.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-204">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center justify-center" data-id="element-205">
              <span className="text-red-700 mr-2" data-id="element-206">★</span>
              Take Action Now
              <span className="text-red-700 ml-2" data-id="element-207">★</span>
            </h3>
            <p className="text-lg text-gray-700 mb-8" data-id="element-208">
              <span className="flex items-center gap-2" data-id="element-209">
                <ArrowRightIcon className="text-red-700 w-5 h-5 flex-shrink-0" data-id="element-210" />
                Don't wait for the next siren, the next headline, the next
                funeral.
              </span>
              <span className="flex items-center gap-2 mt-2" data-id="element-211">
                <ArrowRightIcon className="text-red-700 w-5 h-5 flex-shrink-0" data-id="element-212" />
                Click below to claim your copy of When Schools Become Targets.
              </span>
            </p>
            <a href="#offer" className="inline-block bg-red-700 hover:bg-red-800 text-white font-bold py-4 px-10 rounded-lg text-xl transition-colors duration-300 shadow-md border-2 border-white relative overflow-hidden group" data-id="element-213">
              <span className="relative z-10" data-id="element-214">
                Get My Copy Now – Limited Time Offer
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-gray-700 to-gray-700 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300" data-id="element-215"></span>
            </a>
          </div>
        </div>
      </div>
    </div>;
};